define.alias("shared/types", "settings/types/index");